export default () => {
	$('#frm-change-avatar .frm-upload-photo').click(function (){
		$('#field-avatar').trigger('click')
	})
	$('#field-avatar').change(function (){
		
		readURL(this)
	})
	
	function readURL(input) {
		if (input.files && input.files[0]) {
			const reader = new FileReader()
			
			reader.onload = function (e) {
				$('.preview').html('<img src="' + e.target.result + '"/>')
				// $('#blah').attr('src', e.target.result);
			}
			$('#frm-change-avatar .frm-upload-photo').toggleClass('d-none')
			$('#frm-change-avatar .preview').toggleClass('d-none')
			reader.readAsDataURL(input.files[0])
		}
	}
}